import SplitPane from 'react-split-pane';
import './split-pane.scss';

export default SplitPane;
